import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import ScrollToTop from "./components/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";

// Lazy-load components
const Home = lazy(() => import('./pages/Home'));
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/PrivacyPolicy'));

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      {/* Suspense fallback to display while the component is loading */}
      <Suspense>
 
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terms-of-use" element={<Terms />} />
            <Route path="/privacypolicy" element={<Privacy />} />
          </Routes>
        </div>
      </Suspense>
    </Router>
    </HelmetProvider>
  );
}

export default App;
